module.exports = __webpack_public_path__ + "static/media/stk-free-gift-ch.2b12782d.png";